// sui默认方法初始化

'use strict';

var _constant = require('./constant');

var _constant2 = _interopRequireDefault(_constant);

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 客户端方法ready态
 */
_constant2.default.ready = function (readyFun) {
    if (_constant2.default.native.suiStatus.state > 1) {
        readyFun();
    } else {
        _constant2.default.native.waitingConf._completes.push(readyFun);
    }
};

/**
 * 客户端报错方法
 */
// eslint-disable-next-line no-empty-function
// 通信功能方法
_constant2.default.error = function () {};

/**
 * 客户端鉴权配置方法
 */
_constant2.default.config = function (params) {
    if (!_utils2.default.sdkEnable()) {
        return;
    }
    var appId = params.appId,
        timestamp = params.timestamp,
        nonceStr = params.nonceStr,
        signature = params.signature,
        _success = params.success,
        _error = params.error;

    var query = {
        successName: 'onSuiConfigSuccess',
        errorName: 'onSuiConfigError',
        check: function check(str) {
            // eslint-disable-next-line no-console
            console.error('sui config error, ' + str + ' show not be empty');
            if (_error && typeof _error == 'function') {
                _error({
                    code: 1,
                    msg: 'sui config error, ' + str + ' should not be empty'
                });
            }
            return;
        },
        success: function success(res) {
            if (typeof res === 'string') {
                res = JSON.parse(res);
            }
            if (res.code === 0) {
                _constant2.default.native.suiStatus.state = 1; // 状态已准备
                _constant2.default.native.suiStatus.detail = res.msg;
                _core2.default.getSupport();
                _utils2.default.clear(_constant2.default.native, query.successName, query.errorName);
                if (_success && typeof _success == 'function') {
                    _success({
                        code: 0,
                        msg: res.msg
                    });
                }
            }
        },
        error: function error(res) {
            _constant2.default.native.suiStatus.state = 1; // 状态已准备
            _constant2.default.native.suiStatus.detail = res.msg;
            _utils2.default.clear(_constant2.default.native, query.successName, query.errorName);
            if (_error && typeof _error == 'function') {
                _error({
                    code: 1,
                    msg: res.msg
                });
            }
        }
    };

    _constant2.default.native.debugMode = params.debug || false;
    if (!appId || appId.toString().trim() === '') return query.check('appId');
    if (!nonceStr || nonceStr.toString().trim() === '') return query.check('nonceStr');
    if (!signature || signature.toString().trim() === '') return query.check('signature');
    if (!timestamp || timestamp.toString().trim() === '') return query.check('timestamp');

    _constant2.default.native[query.successName] = query.success;
    _constant2.default.native[query.errorName] = query.error;
    _utils2.default.callUrl(_constant2.default.native, 'sui-js-call://config', _utils2.default.dataFormate({ appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature }), 'sui.native.' + query.successName, 'sui.native.' + query.errorName);
};

/**
 * sui方法注册
 */
_constant2.default.registerFunction = function (exportFunction, name) {
    if (typeof exportFunction == 'function') {
        _constant2.default.native.exportApi[name] = function (callback) {
            try {
                var resultDict = {
                    code: '0',
                    msg: 'success'
                };
                var args = void 0,
                    result = void 0;

                for (var _len = arguments.length, parameters = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    parameters[_key - 1] = arguments[_key];
                }

                if (parameters.length === 1) {
                    switch (Object.prototype.toString.call(parameters[0])) {
                        case '[object Object]':
                            args = parameters[0];
                            break;
                        case '[object String]':
                            try {
                                args = JSON.parse(parameters[0]);
                            } catch (e) {
                                args = parameters[0];
                            }
                            break;
                    }
                    result = exportFunction.call(this, args);
                } else {
                    result = exportFunction.call.apply(exportFunction, [this].concat(parameters));
                }
                if (_utils2.default.isPromise(result)) {
                    result.then(function (res) {
                        resultDict.result = res;
                        _utils2.default.send(callback, resultDict);
                    });
                } else {
                    resultDict.result = result;
                    _utils2.default.send(callback, resultDict);
                }
            } catch (e) {
                _utils2.default.send(callback, {
                    code: '2',
                    msg: e.message
                });
            }
        };
    }
};